module.exports = __webpack_public_path__ + "img/celine.ea5a3cc2.jpg";